export default "__VITE_ASSET__BGqs1723__"